import React from "react";

import { FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";

export const socialIcons = [
  {
    id: 1,
    icon: <FaFacebook className="icon" />,
    url: "https://www.facebook.com/shivamodi456",
  },
  {
    id: 2,
    icon: <FaTwitter className="icon" />,
    url: "https://www.twitter.com/shivammodi456",
  },
  {
    id: 3,
    icon: <FaLinkedin className="icon" />,
    url: "https://www.linkedin.com/in/shivammodi456/",
  },
];
